/*!
 * SG Tier Upsell (Dawn clean)
 * - counts ONLY cart items that have line item property: properties._sg_edu === "1"
 * - that property is set on add-to-cart ONLY for products in collections:
 *   "ubungsmaterial" OR "abzeichen"
 *
 * Markup roots:
 *  Product page: [data-sg-upsell-product]
 *  Cart:         [data-sg-upsell-cart]
 *
 * Root datasets:
 *  data-cart-json-url="/cart.js" (optional)
 *  data-tiers="50|5|CODE5,100|10|CODE10" (min EUR | percent | optional code)
 *  data-sg-mode="full|compact" (cart root only)
 */
(function () {
  "use strict";

  if (window.__SG_UPSELL_V3__) return;
  window.__SG_UPSELL_V3__ = true;

  // ---------- Helpers
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function tpl(str, vars) {
    return String(str || "").replace(/\[\[\s*(\w+)\s*\]\]/g, function (_, k) {
      return (vars && vars[k] != null) ? String(vars[k]) : "";
    });
  }

  function formatEUR(eur) {
    var v = (Math.round(eur * 100) / 100).toFixed(2);
    return v.replace(".", ",") + " €";
  }

  function parseTiers(csv) {
    if (!csv) return [];
    return String(csv)
      .split(",")
      .map(function (x) { return String(x || "").trim(); })
      .filter(Boolean)
      .map(function (part) {
        var bits = part.split("|").map(function (y) { return String(y || "").trim(); });
        return {
          minValueEur: parseFloat((bits[0] || "0").replace(",", ".")) || 0,
          percent: parseInt(bits[1] || "0", 10) || 0,
          code: bits[2] || ""
        };
      })
      .filter(function (t) { return t.minValueEur >= 0 && t.percent >= 0; })
      .sort(function (a, b) { return (a.minValueEur || 0) - (b.minValueEur || 0); });
  }

  function pickTierByValue(valueEur, tiers) {
    var current = null;
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      var t = tiers[i];
      if (valueEur >= (t.minValueEur || 0)) current = t;
      else { next = t; break; }
    }
    return { current: current, next: next };
  }

  // ---------- Cart fetch cache
  var CART_CACHE = { ts: 0, data: null };
  var CART_TTL_MS = 500;

  function fetchCart(cartJsonUrl) {
    var now = Date.now();
    if (CART_CACHE.data && (now - CART_CACHE.ts) < CART_TTL_MS) return Promise.resolve(CART_CACHE.data);
    return fetch(cartJsonUrl, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { CART_CACHE.ts = Date.now(); CART_CACHE.data = cart; return cart; });
  }

  // ---------- Eligibility (line item properties marker)
  function isEligibleItem(item) {
    var props = item && item.properties ? item.properties : null;
    if (!props) return false;
    // Shopify may stringify numbers; accept "1", 1, true
    var v = props._sg_edu;
    return v === "1" || v === 1 || v === true || v === "true";
  }

function computeEligibleSums(cart) {
  var originalSubtotalCents = 0;
  var finalSubtotalCents = 0;
  var items = (cart && cart.items) ? cart.items : [];

  for (var i = 0; i < items.length; i++) {
    var it = items[i];
    if (!isEligibleItem(it)) continue;

    originalSubtotalCents += (it.original_line_price || 0);
    finalSubtotalCents += (it.final_line_price || 0);
  }

  return {
    subtotalCents: originalSubtotalCents,
    finalSubtotalCents: finalSubtotalCents,
    savingsCents: Math.max(0, originalSubtotalCents - finalSubtotalCents),
    valueEur: originalSubtotalCents / 100
  };
}

  function computeProgress(valueEur, curMin, nextMin, hasCur) {
    if (!nextMin) return hasCur ? 100 : 0;
    var span = Math.max(0.01, nextMin - curMin);
    var progressed = Math.max(0, valueEur - curMin);
    return Math.max(0, Math.min(100, Math.round((progressed / span) * 100)));
  }

  // ---------- Styles (full width)
  function ensureStylesOnce() {
    if ($("#sg-upsell-style")) return;
    var style = document.createElement("style");
    style.id = "sg-upsell-style";
    style.textContent = [
      ".sg-upsell{width:100%;max-width:none;display:block;box-sizing:border-box;background:var(--sg-bg,#fff);color:var(--sg-text,#121212);border:var(--sg-border-w,1px) solid var(--sg-border,rgba(0,0,0,.12));border-radius:14px;padding:var(--sg-pad,14px);margin:1rem 0;}",
      ".sg-upsell__title{margin:0 0 .35rem;font-weight:700;font-size:var(--sg-fs-title,16px);line-height:1.2}",
      ".sg-upsell__sub{margin:0 0 .75rem;opacity:.9;font-size:var(--sg-fs-body,14px)}",
      ".sg-upsell__bar{height:12px;border-radius:999px;background:rgba(0,0,0,.10);overflow:hidden;margin:.75rem 0 .35rem}",
      ".sg-upsell__bar>span{display:block;height:100%;width:0%;background:linear-gradient(90deg,var(--sg-bar-from,#111),var(--sg-bar-to,#444))}",
      ".sg-upsell__meta{display:flex;flex-wrap:wrap;gap:.5rem .6rem;align-items:center;margin:.5rem 0 0}",
      ".sg-upsell__pill{display:inline-flex;align-items:center;gap:.35rem;font-size:var(--sg-fs-pill,12px);padding:var(--sg-pill-py,6px) var(--sg-pill-px,10px);border-radius:999px;background:var(--sg-pill-bg,rgba(0,0,0,.04));border:1px solid var(--sg-pill-border,rgba(0,0,0,.10));color:var(--sg-pill-text,#121212);line-height:1.15}",
      ".sg-upsell__note{margin:.6rem 0 0;font-size:var(--sg-fs-body,14px);opacity:.85}",
      ".sg-upsell--compact{padding:12px;margin:.75rem 0}",
      ".sg-upsell__compact-text{font-size:var(--sg-fs-body,14px);margin:0}",
      /* Dawn drawer spacing helpers */
      ".cart-drawer .sg-upsell{margin:12px 0}"
    ].join("\n");
    document.head.appendChild(style);
  }

  // ---------- Product root
  function initProductRoot(root) {
    if (!root || root.dataset.sgInit === "1") return;
    root.dataset.sgInit = "1";

    ensureStylesOnce();

    var cartJsonUrl = root.dataset.cartJsonUrl || "/cart.js";
    var tiers = parseTiers(root.dataset.tiers || "");

    var showProgress = root.dataset.showProgress !== "0";
    var showSavings = root.dataset.showSavings !== "0";

    var I18N = {
      statusEmpty: root.dataset.i18nStatusEmpty || "Lege Artikel in den Warenkorb, um Rabattstufen freizuschalten.",
      statusHas: root.dataset.i18nStatusHas || "Du hast aktuell [[value]] im Warenkorb.",
      tierNone: root.dataset.i18nTierNone || "Stufe: noch keine aktiv",
      tierActive: root.dataset.i18nTierActive || "Stufe: ab [[min]] → [[percent]]% Rabatt",
      nextTier: root.dataset.i18nNextTier || "Nächste: ab [[min]] → [[percent]]% (es fehlen [[remaining]])",
      maxTier: root.dataset.i18nMaxTier || "Nächste: höchste Stufe erreicht",
      savings: root.dataset.i18nSavings || "Ersparnis: [[percent]]% (≈ [[amount]])",
      savingsNone: root.dataset.i18nSavingsNone || "Ersparnis: –"
    };

    var elStatus = root.querySelector("[data-sg-status]");
    var elTier = root.querySelector("[data-sg-tier]");
    var elNext = root.querySelector("[data-sg-next]");
    var elSave = root.querySelector("[data-sg-save]");
    var elBar = root.querySelector("[data-sg-bar]");
    var barWrap = root.querySelector("[data-sg-progress-wrap]");
    var savingsWrap = root.querySelector("[data-sg-savings-wrap]");

    if (barWrap && !showProgress) barWrap.style.display = "none";
    if (savingsWrap && !showSavings) savingsWrap.style.display = "none";

    root.__sgUpdate = function (cart) {
      var sums = computeEligibleSums(cart);
      var valueEur = sums.valueEur || 0;
      var subtotalCents = sums.subtotalCents || 0;

      var picked = pickTierByValue(valueEur, tiers);
      var cur = picked.current;
      var nxt = picked.next;

      var curMin = cur ? cur.minValueEur : 0;
      var curPct = cur ? cur.percent : 0;

      var nextMin = nxt ? nxt.minValueEur : 0;
      var nextPct = nxt ? nxt.percent : 0;

      var remaining = (nextMin && valueEur < nextMin) ? (nextMin - valueEur) : 0;
      var progress = computeProgress(valueEur, curMin, nextMin, !!cur);

      var tierText = (curPct > 0)
        ? tpl(I18N.tierActive, { min: formatEUR(curMin), percent: curPct })
        : I18N.tierNone;

      var nextText = nextMin
        ? tpl(I18N.nextTier, { min: formatEUR(nextMin), percent: nextPct, remaining: formatEUR(remaining) })
        : (cur ? I18N.maxTier : "");

      var saveText = I18N.savingsNone;
if (curPct > 0) {
  var saveCents = sums.savingsCents || 0;
  saveText = tpl(I18N.savings, { percent: curPct, amount: formatEUR(saveCents / 100) });
}

      if (elTier) elTier.textContent = tierText;
      if (elNext) elNext.textContent = nextText;
      if (elSave) elSave.textContent = saveText;
      if (elBar) elBar.style.width = String(progress) + "%";

      if (elStatus) {
        elStatus.textContent = (valueEur > 0)
          ? tpl(I18N.statusHas, { value: formatEUR(valueEur) })
          : I18N.statusEmpty;
      }
    };

    if (elStatus) elStatus.textContent = I18N.statusEmpty;

    fetchCart(cartJsonUrl).then(function (cart) { root.__sgUpdate && root.__sgUpdate(cart); }).catch(function () {});
  }

  // ---------- Cart root
  function initCartRoot(root) {
    if (!root || root.dataset.sgInit === "1") return;
    root.dataset.sgInit = "1";

    ensureStylesOnce();

    var mode = root.dataset.sgMode || "full"; // full|compact
    var cartJsonUrl = root.dataset.cartJsonUrl || "/cart.js";
    var tiers = parseTiers(root.dataset.tiers || "");

    var showProgress = root.dataset.showProgress !== "0";
    var showSavings = root.dataset.showSavings !== "0";

    var headline = root.dataset.headline || "Mehr kaufen, mehr sparen";
    var note = root.dataset.noteText || "";
    var subTpl = root.dataset.i18nSubtitle || "Aktuell: [[value]] im Warenkorb.";

    var I18N = {
      tierNone: root.dataset.i18nTierNone || "Stufe: noch keine aktiv",
      tierActive: root.dataset.i18nTierActive || "Stufe: ab [[min]] → [[percent]]% Rabatt",
      nextTier: root.dataset.i18nNextTier || "Nächste: ab [[min]] → [[percent]]% (es fehlen [[remaining]])",
      maxTier: root.dataset.i18nMaxTier || "Nächste: höchste Stufe erreicht",
      savings: root.dataset.i18nSavings || "Ersparnis: [[percent]]% (≈ [[amount]])",
      savingsNone: root.dataset.i18nSavingsNone || "Ersparnis: –"
    };

    // Build markup once
    root.innerHTML = "";
    var card = document.createElement("div");
    card.className = (mode === "compact") ? "sg-upsell sg-upsell--compact" : "sg-upsell";

    // ✅ WICHTIG: kein Semikolon vor dem ":" – sonst Syntax-Error!
    card.innerHTML = (mode === "compact")
      ? '<p class="sg-upsell__compact-text"><strong data-sg-label></strong> <span data-sg-next></span></p>'
      : (
          '<p class="sg-upsell__title" data-sg-headline></p>' +
          '<p class="sg-upsell__sub" data-sg-sub></p>' +
          '<div class="sg-upsell__bar" data-sg-progress-wrap><span data-sg-bar style="width:0%"></span></div>' +
          '<div class="sg-upsell__meta">' +
            '<span class="sg-upsell__pill"><span data-sg-tier></span></span>' +
            '<span class="sg-upsell__pill"><span data-sg-next></span></span>' +
            '<span class="sg-upsell__pill" data-sg-savings-wrap><span data-sg-save></span></span>' +
          '</div>' +
          '<div class="sg-upsell__note" data-sg-note></div>'
        );

    root.appendChild(card);

    var refs = {
      card: card,
      headline: card.querySelector("[data-sg-headline]"),
      sub: card.querySelector("[data-sg-sub]"),
      tier: card.querySelector("[data-sg-tier]"),
      next: card.querySelector("[data-sg-next]"),
      save: card.querySelector("[data-sg-save]"),
      bar: card.querySelector("[data-sg-bar]"),
      note: card.querySelector("[data-sg-note]"),
      progressWrap: card.querySelector("[data-sg-progress-wrap]"),
      savingsWrap: card.querySelector("[data-sg-savings-wrap]"),
      label: card.querySelector("[data-sg-label]")
    };

    if (refs.progressWrap && !showProgress) refs.progressWrap.style.display = "none";
    if (refs.savingsWrap && !showSavings) refs.savingsWrap.style.display = "none";

    root.__sgUpdate = function (cart) {
      var sums = computeEligibleSums(cart);
      var valueEur = sums.valueEur || 0;
      var subtotalCents = sums.subtotalCents || 0;

      if (valueEur <= 0) {
        refs.card.style.display = "none";
        return;
      }
      refs.card.style.display = "";

      var picked = pickTierByValue(valueEur, tiers);
      var cur = picked.current;
      var nxt = picked.next;

      var curMin = cur ? cur.minValueEur : 0;
      var curPct = cur ? cur.percent : 0;

      var nextMin = nxt ? nxt.minValueEur : 0;
      var nextPct = nxt ? nxt.percent : 0;

      var remaining = (nextMin && valueEur < nextMin) ? (nextMin - valueEur) : 0;
      var progress = computeProgress(valueEur, curMin, nextMin, !!cur);

      var tierText = (curPct > 0)
        ? tpl(I18N.tierActive, { min: formatEUR(curMin), percent: curPct })
        : I18N.tierNone;

      var nextText = nextMin
        ? tpl(I18N.nextTier, { min: formatEUR(nextMin), percent: nextPct, remaining: formatEUR(remaining) })
        : (cur ? I18N.maxTier : "");

      var saveText = I18N.savingsNone;
if (curPct > 0) {
  var saveCents = sums.savingsCents || 0;
  saveText = tpl(I18N.savings, { percent: curPct, amount: formatEUR(saveCents / 100) });
}

      // ✅ Compact: nur Label + Next anzeigen und dann raus
      if (mode === "compact") {
        var compactLabel = root.dataset.i18nCompactLabel || "Rabattstufe:";
        if (refs.label) refs.label.textContent = compactLabel;
        if (refs.next) refs.next.textContent = nextText;
        return;
      }

      // Full
      if (refs.headline) refs.headline.textContent = headline;
      if (refs.sub) refs.sub.textContent = tpl(subTpl, { value: formatEUR(valueEur) });
      if (refs.tier) refs.tier.textContent = tierText;
      if (refs.next) refs.next.textContent = nextText;
      if (refs.save) refs.save.textContent = saveText;
      if (refs.bar) refs.bar.style.width = String(progress) + "%";
      if (refs.note) refs.note.textContent = note;
    };

    fetchCart(cartJsonUrl)
      .then(function (cart) { root.__sgUpdate && root.__sgUpdate(cart); })
      .catch(function () {});
  }


  // ---------- Roots + refresh
  var productRoots = new Set();
  var cartRoots = new Set();

  function registerRoots(container) {
    $all("[data-sg-upsell-product]", container).forEach(function (n) { productRoots.add(n); });
    $all("[data-sg-upsell-cart]", container).forEach(function (n) { cartRoots.add(n); });
  }

  var refreshTimer = null;
  var refreshInFlight = null;

  function refreshAll() {
    if (refreshInFlight) return refreshInFlight;

    productRoots.forEach(initProductRoot);
    cartRoots.forEach(initCartRoot);

    var cartJsonUrl = "/cart.js";
    var any = null;
    cartRoots.forEach(function (r) { if (!any) any = r; });
    if (!any) productRoots.forEach(function (r) { if (!any) any = r; });
    if (any && any.dataset.cartJsonUrl) cartJsonUrl = any.dataset.cartJsonUrl;

    refreshInFlight = fetchCart(cartJsonUrl)
      .then(function (cart) {
        cartRoots.forEach(function (r) { try { r.__sgUpdate && r.__sgUpdate(cart); } catch (e) {} });
        productRoots.forEach(function (r) { try { r.__sgUpdate && r.__sgUpdate(cart); } catch (e) {} });
      })
      .finally(function () { refreshInFlight = null; });

    return refreshInFlight;
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAll, 150);
  }

  function isCartEndpoint(url) {
    if (!url) return false;
    var u = String(url);
    return (
      u.indexOf("/cart/add") !== -1 ||
      u.indexOf("/cart/change") !== -1 ||
      u.indexOf("/cart/update") !== -1 ||
      u.indexOf("/cart/clear") !== -1 ||
      u.indexOf("/cart.js") !== -1
    );
  }

  function hookNetwork() {
    try {
      if (!window.__SG_UPSELL_FETCH_WRAPPED__ && typeof window.fetch === "function") {
        window.__SG_UPSELL_FETCH_WRAPPED__ = true;
        var _fetch = window.fetch;
        window.fetch = function () {
          var args = arguments;
          var url = args[0];
          return _fetch.apply(this, args).then(function (res) {
            try { if (isCartEndpoint(url) || isCartEndpoint(res && res.url)) scheduleRefresh(); } catch (e) {}
            return res;
          });
        };
      }
    } catch (e) {}

    try {
      if (!window.__SG_UPSELL_XHR_WRAPPED__) {
        window.__SG_UPSELL_XHR_WRAPPED__ = true;
        var _open = XMLHttpRequest.prototype.open;
        var _send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.open = function (method, url) { this.__sgUrl = url; return _open.apply(this, arguments); };
        XMLHttpRequest.prototype.send = function () {
          this.addEventListener("loadend", function () { try { if (isCartEndpoint(this.__sgUrl)) scheduleRefresh(); } catch (e) {} });
          return _send.apply(this, arguments);
        };
      }
    } catch (e) {}
  }

  function boot() {
    registerRoots(document);

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < (m.addedNodes ? m.addedNodes.length : 0); j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && (n.matches("[data-sg-upsell-product]") || n.matches("[data-sg-upsell-cart]"))) {
            registerRoots(n); scheduleRefresh();
          } else if (n.querySelector && (n.querySelector("[data-sg-upsell-product]") || n.querySelector("[data-sg-upsell-cart]"))) {
            registerRoots(n); scheduleRefresh();
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener("shopify:section:load", function (e) {
      if (e && e.target) { registerRoots(e.target); scheduleRefresh(); }
    });

    hookNetwork();
    refreshAll();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
